import React from 'react';
import _, { get } from 'lodash';
import PropTypes from 'prop-types';
import moment from 'moment';
import StatusIcon from 'modules/common/components/StatusIcon';
import { convertToUpperCase } from 'helper';

function Transaction({
  module,
  transactionInfo,
}) {
  const spanGap = 8;
  const transactionStatus = get(transactionInfo, 'attributes.transaction_status');
  const dataTransactionType = get(transactionInfo, 'attributes.transaction_type');
  const serialNo = get(transactionInfo, 'included.module.attributes.serial_number_complete', '--');

  return (
    <>
      <div className="p-3" style={{ maxHeight: '700px', overflowY: 'scroll' }}>
        <table className="transaction-table table table-borderless table-sm">
          <tbody>
            <tr className="d-flex">
              <td colSpan={spanGap}>
                <span className="title" style={{ fontSize: '16px' }}>
                  TRANSACTION INFORMATION
                </span>
              </td>
            </tr>
            <tr>
              <td className="text-dark" colSpan={spanGap}>
                Module
              </td>
              <td className="text-dark" width="1">
                :
              </td>
              <td colSpan={4}>
                <b>{convertToUpperCase(get(transactionInfo, 'attributes.permit_type'))}</b>
              </td>
            </tr>
            <tr>
              <td className="text-dark" colSpan={spanGap}>
                Transaction Type
              </td>
              <td className="text-dark" width="1">
                :
              </td>
              <td colSpan={4}>
                <b>{dataTransactionType || '--'}</b>
              </td>
            </tr>
            <tr>
              <td className="text-dark" colSpan={spanGap}>
                Transaction ID
              </td>
              <td className="text-dark" width="1">
                :
              </td>
              <td colSpan={4}>
                <b>{get(transactionInfo, 'attributes.txnid') || '--'}</b>
              </td>
            </tr>
            <tr>
              <td className="text-dark" colSpan={spanGap}>
                Date
              </td>
              <td className="text-dark" width="1">
                :
              </td>
              <td colSpan={4}>
                <b>
                  {_.get(transactionInfo, 'attributes.transaction_date')
                    ? moment(
                        _.get(transactionInfo, 'attributes.transaction_date')
                      ).format('MMMM DD, YYYY')
                    : `--`}
                </b>
              </td>
            </tr>
            <tr>
              <td className="text-dark" colSpan={spanGap}>
                Status
              </td>
              <td className="text-dark" width="1">
                :
              </td>
              <td colSpan={4}>
                <b>
                  <StatusIcon
                    value={transactionStatus}
                  />
                </b>
              </td>
            </tr>
            <tr>
              <td className="text-dark" colSpan={spanGap}>
                Remarks
              </td>
              <td className="text-dark" width="1">
                :
              </td>
              <td colSpan={4}>
                <b>
                  {get(transactionInfo, 'attributes.remarks') || '--'}
                </b>
              </td>
            </tr>
            <tr>
              <td className="text-dark" colSpan={spanGap}>
                Amount
              </td>
              <td className="text-dark" width="1">
                :
              </td>
              <td colSpan={4}>
                <b>
                  {get(transactionInfo, 'attributes.amount') || '--'}
                </b>
              </td>
            </tr>
            {module === 'cdl' && (
              <tr>
                <td className="text-dark" colSpan={spanGap}>
                  Serial Number
                </td>
                <td className="text-dark" width="1">
                  :
                </td>
                <td colSpan={4}>
                  <b>
                    {serialNo}
                  </b>
                </td>
              </tr>
            )}
            <tr className="d-flex">
              <td colSpan={spanGap}>
                <span className="title" style={{ fontSize: '16px' }}>
                  PAYMENT INFORMATION
                </span>
              </td>
            </tr>
            <tr>
              <td className="text-dark" colSpan={spanGap}>
                Channel
              </td>
              <td className="text-dark" width="1">
                :
              </td>
              <td colSpan={4}>
                <b>{get(transactionInfo, 'attributes.payment_channel') || '--'}</b>
              </td>
            </tr>
            <tr>
              <td className="text-dark" colSpan={spanGap}>
                Branch
              </td>
              <td className="text-dark" width="1">
                :
              </td>
              <td colSpan={4}>
                <b>{get(transactionInfo, 'attributes.payment_channel_branch') || '--'}</b>
              </td>
            </tr>
            <tr>
              <td className="text-dark" colSpan={spanGap}>
                Date
              </td>
              <td className="text-dark" width="1">
                :
              </td>
              <td colSpan={4}>
                <b>
                  {_.get(transactionInfo, 'attributes.payment_date')}
                </b>
              </td>
            </tr>
            <tr>
              <td className="text-dark" colSpan={spanGap}>
                Status
              </td>
              <td className="text-dark" width="1">
                :
              </td>
              <td colSpan={4}>
                <b>{get(transactionInfo, 'attributes.status') || '--'}</b>
              </td>
            </tr>
            <tr>
              <td className="text-dark" colSpan={spanGap}>
                Reference Number
              </td>
              <td className="text-dark" width="1">
                :
              </td>
              <td colSpan={4}>
                <b>{get(transactionInfo, 'attributes.refno') || '--'}</b>
              </td>
            </tr>
            <tr>
              <td className="text-dark" colSpan={spanGap}>
                OR Number
              </td>
              <td className="text-dark" width="1">
                :
              </td>
              <td colSpan={4}>
                <b>
                  {_.get(transactionInfo, 'attributes.or_number', '--')}
                </b>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </>
  );
}

Transaction.propTypes = {
  module: PropTypes.string.isRequired,
  transactionInfo: PropTypes.instanceOf(Object).isRequired,
};

export default Transaction;
